export default {
    path: '/taskPanel',
    name: 'TaskPanel',
    component: () => import(/* webpackChunkName: "taskPanel" */ '../../views/taskPanel/taskPanel.vue')
}